export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13338.1604fc46.jpg";